export default __webpack_public_path__ + "bf99cb3daa87726a8627fc0fa319322f.png";